import { useEffect, type RefObject } from 'react';

/**
 * The height cap of a composer popup's list: never taller than the room the popover has on screen, less
 * its own `p-1` padding, so the first rows cannot end up past the window edge. The rest scrolls.
 */
export const COMPOSER_POPOVER_LIST_HEIGHT =
  'max-h-[min(480px,calc(var(--radix-popover-content-available-height)-8px))]';

/**
 * Keeps the highlighted row in view. The arrow keys move the highlight from the textarea, which keeps
 * the focus, so cmdk never scrolls the list itself. Rows are matched by value rather than by a selector,
 * because a value can hold any character.
 */
export function useScrollHighlightIntoView(
  listRef: RefObject<HTMLDivElement | null>,
  open: boolean,
  highlighted: string,
): void {
  useEffect(() => {
    if (!open || highlighted === '') return;
    const rows = listRef.current?.querySelectorAll('[cmdk-item]') ?? [];
    for (const row of rows) {
      if (row.getAttribute('data-value') === highlighted) {
        row.scrollIntoView({ block: 'nearest' });
        return;
      }
    }
  }, [listRef, open, highlighted]);
}
